
export default {
    roomShareNote: (state, getters, rootState) => {
        return rootState.room.roomShareNote;
    },
    // getShareNoteLogs: (state, getters, rootState) => () => {
    //     return state.logs;
    // }

    hasWaitingUser: (state, getters, rootState) => {
        return state.waitingList.length > 0;
    }
}
